// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import axiosInstance from 'providers/axiosInstance/axiosInstance';
import useLogger from 'core/utils/useLogger';
import { REACT_APP_API_URL_ORG } from 'config';

const fetchPrograms = async (
  setUserProgramList: React.Dispatch<React.SetStateAction<any[]>>
): Promise<void> => {
  try {
    const programApiUrl = `${REACT_APP_API_URL_ORG}/${apiEndpoint.getProgramRoles}/`;

    const programApiResponse = await axiosInstance.get(`${programApiUrl}`);

    const responseData = (programApiResponse.data as any)?.results || [];
    const data = responseData.map((item) => ({
      label: item.iprogram_name,
      value: item.iprogram_unique_id,
      ...item,
    }));
    await setUserProgramList(data);
  } catch (error) {
    if (error?.response?.data) {
      const logger = useLogger();
      setUserProgramList([]);
      logger('Error in fecthing roles', error);
    }
  }
};

export default fetchPrograms;
